import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';


export class ChPagerComponent {

   total = 0;
   pageSize = 0;
   pageIndexChange = new EventEmitter<number>();
  pageIndex = 1;
  totalPage = 1;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.pageIndex = Math.max(Math.min(this.pageIndex, this.total), 1);
  }

  skipPrev() {
    if (this.isPrev()) {
      this.pageIndex = Number(this.pageIndex) - 1;
      this.onChangePageIndex(this.pageIndex);
    }
  }

  skipNext() {
    if (this.isNext()) {
      this.pageIndex = Number(this.pageIndex) + 1;
      this.onChangePageIndex(this.pageIndex);
    }
  }

  isPrev() {
    return this.pageIndex > 1;
  }

  isNext() {
    return this.pageIndex < this.getTotalPage();
  }

  private getTotalPage() {
    this.totalPage = Math.ceil(this.total / this.pageSize)
    return this.totalPage;
  }

  onChangePageIndex(pageIndex) {
    this.pageIndexChange.emit(pageIndex);
  }



static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-pager',
  template: "\n    <nav><ul class=\"pager\"><li><a [ngClass]=\"{ 'disabled': !isPrev()}\" (click)=\"skipPrev()\">«上一页</a></li><li><a [ngClass]=\"{ 'disabled': !isNext()}\" (click)=\"skipNext()\">下一页»</a></li></ul></nav>\n  ",
  styles: ["\n    .disabled{cursor:not-allowed}\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'total': [{ type: Input },],
'pageSize': [{ type: Input },],
'pageIndexChange': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
